import { Component } from 'react';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

// eslint-disable-next-line import/no-cycle
import { FormError, Modal } from 'common/components/layout';
import { removeSpaces } from 'common/helpers/miscHelper';
import { integerFormat } from 'common/helpers/numberHelper';
import {
  addCustomerCreditCard,
  listCustomerCreditCards
} from 'redux/customerCreditCards/actions';

import AddEditForm from '../components/AddEditForm';
import { validateAdd } from '../validators';

class AddModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false
    };
  }

  handleSubmit = async (form) => {
    this.setState({
      isSubmitting: true
    });
    const { props } = this;
    const data = transformData(form);
    const { executeRecaptcha } = props.googleReCaptchaProps;
    const token = await executeRecaptcha('creditCardUpdate');
    data.recaptchaToken = token;

    const successFunction = (creditCard) => {
      props.onAddCreditCard(creditCard);
    };
    props.addCustomerCreditCard(data, successFunction);
  };

  render() {
    const { customerCreditCards } = this.props;
    const { handleSubmit, form } = this.props;
    const { onCloseModal, cancelFunction = onCloseModal } = this.props;
    const isFirstCard = customerCreditCards.recordCount === 0 || false;
    const { isSubmitting } = this.state;

    return (
      <Modal title="Add Credit Card" onCloseModal={onCloseModal}>
        <FormError formName={form} />
        <AddEditForm
          onSubmit={handleSubmit(this.handleSubmit)}
          saveButtonText={!isSubmitting ? 'Add Credit Card' : 'Loading...'}
          onCancelFunction={cancelFunction}
          isFirstCard={isFirstCard}
        />
      </Modal>
    );
  }
}

const transformData = (values) => {
  const data = {
    cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
    expiryMo: values.expiryMo && integerFormat(values.expiryMo),
    expiryYr: values.expiryYr && integerFormat(values.expiryYr),
    cvv2: values.cvv2,
    cardHolderName: values.cardHolderName,
    isDefault: values.isDefault
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateAdd(data);
  return errors;
};

const mapStateToProps = (state) => ({
  customerCreditCards: state.customerCreditCard
});

AddModal = reduxForm({
  form: 'AddModal',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(AddModal);

export default withGoogleReCaptcha(
  connect(mapStateToProps, {
    addCustomerCreditCard,
    listCustomerCreditCards
  })(AddModal)
);
